export enum DataTableTemplatesEnum {
    BooleanTemplate = 'booleanTemplate',
    DateTemplate = 'dateTemplate',
    NumberTemplate = 'numberTemplate',
    VisibilityTemplate = 'visibilityTemplate',
}
